<!-- Modal overlay when lands popover is visible -->
@if (isLandsPopoverVisible) {
  <div class="modal-overlay" (click)="onOverlayClick($event)"></div>
}

<div id="navigationBar">
  <div class="navbar-top-menu">
    <dk-doktar-icon class="navbar-logo-icon" />
    @for (item of menuItems; track item) {
      @if (item.visible) {
        <a
          pButton
          [icon]="item.icon"
          class="navbar-button"
          [class.active]="isActiveRoute(item.routerLink)"
          [class.disabled-button]="isLandsPopoverVisible && item.routerLink !== '/lands'"
          [outlined]="true"
          [text]="true"
          [pTooltip]="!isLandsPopoverVisible ? (item.label | translate) : ''"
          [tooltipPosition]="'right'"
          (click)="onClickMenuItem(item)"
          [attr.id]="'item-' + item.routerLink">
      </a>
      @if (item.key === 'land_and_plants') {
        <p-popover
          #landsPopover
          appendTo="body"
          [dismissable]="false"
          (onEscapeKeydown)="preventEscapeClose($event)"
          [style]="{
            width: '320px',
            marginTop: '-55px',
            marginLeft: '40px',
            height: 'auto',
            borderRadius: '12px',
            zIndex: '10002',
          }">
          <ng-template #content>
            <div class="first-land-container">
              <div class="text-container">
                <span class="title">
                  {{ 'doktar_app.land_plantations.lands_tutorial_title' | translate }}
                </span>
                <span class="description">
                  {{ 'doktar_app.land_plantations.lands_tutorial_desc' | translate }}
                </span>
              </div>
              <div class="icon-container">
                <dk-first-land-icon />
              </div>
            </div>

            <div class="buttons">
              <dk-button
                severity="primary"
                (onClick)="goToLandRegistration()"
                [label]="'doktar_app.land_plantations.lands_home.add_land' | translate"></dk-button>
            </div>
          </ng-template>
        </p-popover>
      }
      }
    }
  </div>
  <div class="navbar-bottom-menu">
    <div class="navbar-bottom-buttons">
      @for (item of subMenuItems; track item) {
        @if (item.visible) {
            <a
              pButton
              [icon]="item.icon"
              class="navbar-button"
              [class.active]="item.key === 'notifications' ? false :isActiveRoute(item.routerLink)"
              [class.disabled-button]="isLandsPopoverVisible"
              [outlined]="true"
              [text]="true"
              [pTooltip]="!isLandsPopoverVisible ? (item.label | translate) : ''"
              [tooltipPosition]="'right'"
              (click)="item.key === 'notifications' ? onNotificationsClick() : onClickMenuItem(item)">
              @if(item.key === 'notifications' && unreadCount > 0) {
                <p-badge class="notification-badge" [value]="unreadCount" badgeSize="small" />
              }
            </a>
        }
      }
    </div>
    <a
      pButton
      class="account-button"
      [class.disabled-button]="isLandsPopoverVisible"
      [outlined]="true"
      [text]="true"
      (click)="navigateToAccount()"
      [pTooltip]="!isLandsPopoverVisible ? ('doktar_app.menu.account' | translate) : ''"
      [tooltipPosition]="'right'">
      <p-avatar [label]="profileLabelLetters" size="large" shape="circle" />
    </a>
  </div>
</div>
